import Vue from 'vue'
import VueCookie from 'vue-cookie'
import * as types from '../mutation-types'
import {
  updateProfile,
  getUserCategory,
  addPointReward,
  getSavedPlaces,
  checkValidReferrer,
  getReferralHistory,
  getReferralDetail,
  switchStatusAutoTransferCod,
  getListPaymentMethods,
  bindZaloPay,
  bindMomo,
  unbindWallet,
  // checkBalanceZaloPay,
  profile,
  payOrderByZaloPayWithAutoDebit,
  payOrderByMomoWithAutoDebit,
  verifyAccount,
  getScreenConfig,
  getDriver,
  addDriver,
  removeDriver,
  bindShopeePay,
  payOrderByShopeePayWithAutoDebit,
  getShopeePayToken,
  refreshFirebaseToken,
  getListPartner
} from '../api/user'

import {
  preHTTPS,
  formatPhoneNumber,
  updateItemStorage,
  getItemStorage,
  getFCMSubscriptionToken
} from '../../plugins/util'
import { getListEmployees } from '../api/user'
import { loadbankList } from '../api/common'
const { findIndex, cloneDeep, groupBy } = require('@/plugins/lodash')
import {
  COOKIE_NAME__PICKUP_LOCATION,
  COOKIE_NAME__SELECT_ADDRESS_PICKUP_HINT,
  COOKIE_NAME__SELECT_SERVICE_HINT,
  COOKIE_NAME__SELECT_ADDRESS_HINT,
  COOKIE_NAME__SELECT_ADDRESS_DROPOFF_HINT,
  COOKIE_NAME__SELECT_PROMO_HINT,
  COOKIE_EXPIRES_MAX_AGE__6M,
  LOCAL_STORAGE_KEY__USER,
  LOCAL_STORAGE_KEY__FINGERPRINT
} from '../../mixins/constants'
import { globalMethods } from '@/mixins/globalMixin'

const instruction = [
  {
    name: COOKIE_NAME__SELECT_ADDRESS_PICKUP_HINT,
    show: true
  },
  {
    name: COOKIE_NAME__SELECT_SERVICE_HINT,
    show: false
  },
  {
    name: COOKIE_NAME__SELECT_ADDRESS_HINT,
    show: false
  },
  {
    name: COOKIE_NAME__SELECT_ADDRESS_DROPOFF_HINT,
    show: true
  },
  {
    name: COOKIE_NAME__SELECT_PROMO_HINT,
    show: true
  }
]

const toolTipSameScreen = [COOKIE_NAME__SELECT_SERVICE_HINT, COOKIE_NAME__SELECT_ADDRESS_HINT]

instruction.some((item) => {
  if (
    VueCookie.get(COOKIE_NAME__PICKUP_LOCATION) &&
    !VueCookie.get(item.name) &&
    toolTipSameScreen.includes(item.name)
  ) {
    item.show = true
    return true
  } else return false
})

const state = {
  token: '',
  profile: undefined,
  signInFallback: undefined,
  fingerprint: undefined,
  employees: [],
  instruction,
  startROTourFromNewOrder: false,
  openSelectCategory: false,
  bankList: null,
  branchBankList: null,
  exampleExtract: [],
  partnerGetFromToken: null,

  // category states
  userCategory: null, // master data from api: list user categories
  loadingUserCategory: false,
  userBusiness: null,
  userCategoryGroups: [], // selected category groups
  userCategories: [], // selected categories
  savedPlaces: [],
  loadingSavedPlaces: false,
  loadedSavedPlaces: false,

  loadingProfile: true,
  is_binding_zalo_success: false,
  is_auto_debit_zalopay: false,
  is_binding_spp_success: false,
  is_auto_debit_spp: false,
  is_auto_debit_momo: false,
  tempCategoryVerifyAccount: [],

  //favorite driver
  favorite_drivers: [],
  loadingFavoriteDriver: false
}

const getters = {
  userProfile: (state) => state.profile,
  token: (state) => state.token,
  theme: (state) => state.theme,
  signInFallback: (state) => state.signInFallback,
  fingerprint: (state) => state.fingerprint,
  loginParams: (state, getters, rootState) => {
    const pushToken = getFCMSubscriptionToken() || process.env.VUE_APP_PLATFORM
    const payload = {
      imei:
        state.fingerprint ||
        getItemStorage(LOCAL_STORAGE_KEY__FINGERPRINT) ||
        process.env.VUE_APP_PLATFORM,
      type: process.env.VUE_APP_PLATFORM,
      push: pushToken,
      fcm: true
    }

    if (rootState.webInAppConfig && rootState.webInAppConfig.userId) {
      payload.imei = rootState.webInAppConfig.userId
      payload.ewallet_id = rootState.webInAppConfig.userId
      payload.webinapp = rootState.webInAppConfig.id
    }

    return payload
  },
  employees: (state) => state.employees,
  instruction: (state) => state.instruction,
  // kaProfile: (state) => {
  //   return state.profile && state.profile.ka_profile
  // },
  startROTourFromNewOrder: (state) => state.startROTourFromNewOrder,
  openSelectCategory: (state) => state.openSelectCategory,
  userBankInfo: (state) => {
    if (
      state.profile &&
      state.profile.wallet_info &&
      state.profile.wallet_info.bank &&
      state.profile.wallet_info.bank.account_id
    ) {
      const bank = state.profile.wallet_info.bank

      return {
        bankName: bank.name,
        accountNumber: bank.account_id,
        accountHolder: bank.account_name,
        branchBankName: bank.branch,
        lastUpdate: bank.last_update
      }
    } else return null
  },
  getExampleExtract: (state) => state.exampleExtract,
  listCategoryGroup: (state) => {
    if (state.userCategory && state.userBusiness) {
      return state.userCategory.filter((c) => c.level === 1 && state.userBusiness === c.type)
    } else return []
  },
  listCategory: (state) => {
    if (state.userCategory && state.userBusiness) {
      let list = []
      state.userCategory.forEach((c) => {
        if (c.level === 2 && state.userBusiness === c.type) {
          let category = { ...c }
          const parent = state.userCategory.find((p) => p.code === c.parent_code)
          category.parent_name = (parent && parent.name) || {}

          list.push(category)
        }
      })
      return list
    } else return []
  },

  isExistedZaloPayWallet: (state) => {
    return (
      state.profile.extra && state.profile.extra.eWallet && state.profile.extra.eWallet.zalo_pay
    )
  },
  isZaloPayWalletUnavailable: (state) => {
    return (
      state.profile.extra &&
      state.profile.extra.eWallet &&
      state.profile.extra.eWallet.zalo_pay &&
      state.profile.extra.eWallet.zalo_pay.status === 'disabled'
    )
  },
  loadingProfile: (state) => state.loadingProfile,
  isBindZaloSuccess: (state) => state.is_binding_zalo_success,
  isAutoDebitZaloPay: (state) => state.is_auto_debit_zalopay,
  isAutoDebitMomo: (state) => state.is_auto_debit_momo,

  isExistedShopeePayWallet: (state) => {
    return (
      state.profile.extra && state.profile.extra.eWallet && state.profile.extra.eWallet.shopeepay
    )
  },
  isShopeePayWalletUnavailable: (state) => {
    return (
      state.profile.extra &&
      state.profile.extra.eWallet &&
      state.profile.extra.eWallet.shopeepay &&
      state.profile.extra.eWallet.shopeepay.status === 'disabled'
    )
  },
  isBindShopeePaySuccess: (state) => state.is_binding_spp_success,
  isAutoDebitShopeePay: (state) => state.is_auto_debit_spp,
  partnerGetFromToken: (state) => state.partnerGetFromToken
}

const refactorProfile = function (profile) {
  if (profile) {
    if (profile.login_with === 'facebook' && profile.facebook_id) {
      profile.avatar = 'https://graph.facebook.com/' + profile.facebook_id + '/picture?type=normal'
    } else if (profile.login_with === 'google' && profile.google_id) {
      console.log('login with google')
    }

    profile.avatar = preHTTPS(profile.avatar)
    profile.phone = formatPhoneNumber(profile.country_code, profile._id)
  }
}

const mutations = {
  [types.SIGNIN](state, data) {
    Vue.set(state, 'token', data.token)
    refactorProfile(data.profile)
    Vue.set(state, 'profile', data.profile)
  },
  [types.SET_TOKEN](state, token) {
    Vue.set(state, 'token', token)
  },
  [types.SET_THEME](state, theme) {
    Vue.set(state, 'theme', theme)
  },
  [types.SET_USER_PROFILE](state, profile) {
    refactorProfile(profile)
    Vue.set(state, 'profile', profile)
  },

  [types.SET_SIGNIN_FALLBACK](state, data) {
    state.signInFallback = data
  },
  [types.UPDATE_PROFILE](state, data) {
    state.profile = data
  },
  [types.SIGNOUT](state) {
    Vue.set(state, 'token', null)
    Vue.set(state, 'profile', null)
    Vue.set(state, 'employees', [])
    Vue.set(state, 'userBusiness', null)
    Vue.set(state, 'userCategoryGroups', [])
    Vue.set(state, 'userCategories', [])
    Vue.set(state, 'partnerGetFromToken', null)
  },
  [types.SET_FINGERPRINT](state, data) {
    Vue.set(state, 'fingerprint', data)
  },
  [types.GET_EMPLOYEES](state, data) {
    Vue.set(state, 'employees', data)
  },
  [types.SET_INSTRUCTION](state, data) {
    Vue.set(state, 'instruction', data)
  },
  [types.SET_START_RO_TOUR_FROM_NEW_ORDER](state, data) {
    state.startROTourFromNewOrder = data
  },
  [types.SET_OPEN_SELECT_CATEGORY](state, data) {
    state.openSelectCategory = data
  },
  [types.UPDATE_BANK_INFO](state, data) {
    state.profile = {
      ...state.profile,
      ...data
    }
  },
  [types.UPDATE_BANKS_LIST](state, data) {
    state.bankList = data
  },
  [types.UPDATE_BRANCH_BANKS_LIST](state, data) {
    state.branchBankList = data
  },
  [types.LOADING_USER_CATEGORY](state, value) {
    state.loadingUserCategory = value
  },
  [types.LOAD_USER_CATEGORY_SUCCESS](state, data) {
    state.userCategory = data
  },
  [types.UPDATE_USER_CATEGORIES](state, data) {
    state.userCategories = data
  },
  [types.UPDATE_USER_CATEGORY_GROUPS](state, data) {
    state.userCategoryGroups = data
  },
  [types.UPDATE_USER_BUSINESS](state, data) {
    state.userBusiness = data
  },
  [types.ADD_USER_CATEGORY](state, data) {
    state.userCategory = data
  },
  [types.LOADING_SAVED_PLACES](state, data) {
    state.loadingSavedPlaces = data
  },
  [types.LOAD_SAVED_PLACES_SUCCESS](state, data) {
    state.savedPlaces = data
  },
  [types.LOADED_SAVED_PLACES](state, data) {
    state.loadedSavedPlaces = data
  },
  [types.ADD_LOCAL_SAVED_PLACE](state, data) {
    state.savedPlaces = data
  },
  [types.REMOVE_LOCAL_SAVED_PLACE](state, data) {
    state.savedPlaces = data
  },

  [types.SET_STATUS_BIND_ZALOPAY](state, data) {
    state.is_binding_zalo_success = data
  },

  [types.SET_AUTO_DEBIT_ZALOPAY](state, data) {
    state.is_auto_debit_zalopay = data
  },

  [types.SET_AUTO_DEBIT_MOMO](state, data) {
    state.is_auto_debit_momo = data
  },

  [types.LOADING_FAVORITE_DRIVER](state, data) {
    state.loadingFavoriteDriver = data
  },

  [types.LOAD_FAVORITE_DRIVER_SUCCESS](state, data) {
    state.favorite_drivers = data
  },

  [types.SET_STATUS_BIND_SHOPEEPAY](state, data) {
    state.is_binding_spp_success = data
  },

  [types.SET_AUTO_DEBIT_SHOPEEPAY](state, data) {
    state.is_auto_debit_spp = data
  },

  [types.SET_PARTNER_GET_FROM_TOKEN](state, data) {
    state.partnerGetFromToken = data
  }
}

const actions = {
  signin: ({ commit }, data) => {
    commit(types.SIGNIN, data)
  },

  setUserProfile: ({ commit }, profile) => {
    commit(types.SET_USER_PROFILE, profile)
  },
  setToken: ({ commit }, token) => {
    commit(types.SET_TOKEN, token)
  },
  setTheme: ({ commit }, theme) => {
    commit(types.SET_THEME, theme)
  },
  setSigninFallback: ({ commit }, data) => {
    commit(types.SET_SIGNIN_FALLBACK, data)
  },
  updateProfile: ({ commit }, profile) => {
    commit(types.UPDATE_PROFILE, profile)
  },
  signOut: ({ commit }, data) => {
    commit(types.SIGNOUT, data)
  },
  setFingerprint: ({ commit }, data) => {
    commit(types.SET_FINGERPRINT, data)
  },
  getEmployees: ({ commit, state }) => {
    getListEmployees({ params: { token: state.token } })
      .then((response) => {
        const data = response.data
        if (data && data.length > 0) {
          let employees = data.map((employee) => {
            // employee.avatar = `${process.env.VUE_APP_API_URL}${API.supplier.file}?id=${employee._id}&file_id=avatar&size=128`
            employee.phone = formatPhoneNumber(employee.country_code, employee._id)
            return employee
          })
          employees = employees.concat({
            _id: state.profile._id,
            name: state.profile.name,
            // avatar:`${process.env.VUE_APP_API_URL}${API.supplier.file}?id=${state.profile._id}&file_id=avatar&size=128`,
            phone: formatPhoneNumber(state.profile.country_code, state.profile._id)
          })
          commit(types.GET_EMPLOYEES, employees)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  },
  closeToolTip: ({ commit, state }, { name, next }) => {
    const instruction = cloneDeep(state.instruction)
    const index = findIndex(instruction, (item) => item.name === name)

    if (index != -1) {
      instruction[index].show = false
      const tourTime = new Date().getTime()
      VueCookie.set(name, tourTime, { expires: COOKIE_EXPIRES_MAX_AGE__6M })

      if (index + 1 < instruction.length) {
        if (next) instruction[index + 1].show = true
      }
      commit(types.SET_INSTRUCTION, instruction)
    }
  },
  setTooltipToView: ({ commit, state }, name) => {
    if (name) {
      const instruction = cloneDeep(state.instruction)
      instruction.forEach((item) => {
        if (item.name === name) item.show = true
      })

      commit(types.SET_INSTRUCTION, instruction)
    }
  },
  createOrderTag: ({ commit, state }, name) => {
    return new Promise((resolve, reject) => {
      if (!name || !state.profile || !state.token) {
        return reject()
      }

      let orderTags = []
      let editObject = { extra: {} }

      if (state.profile.extra) {
        if (state.profile.extra.order_tags) {
          orderTags = [...state.profile.extra.order_tags]
        }

        editObject = {
          extra: { ...state.profile.extra }
        }
      }

      if (orderTags.includes(name)) {
        return reject('order_tag.create_duplicate')
      }

      if (Array.isArray(name)) orderTags = orderTags.concat(name)
      else orderTags.push(name)

      editObject = {
        extra: {
          ...editObject.extra,
          order_tags: orderTags
        }
      }

      const params = { ...editObject, token: state.token }

      updateProfile(params)
        .then((res) => {
          if (res.data) {
            const newProfile = { ...state.profile, ...editObject }
            commit(types.UPDATE_PROFILE, newProfile)

            updateItemStorage(LOCAL_STORAGE_KEY__USER, editObject)
            resolve()
          } else {
            reject()
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  deleteOrderTag: ({ commit, state }, name) => {
    return new Promise((resolve, reject) => {
      if (!name || !state.profile || !state.token) {
        return reject()
      }

      let orderTags = []
      let editObject = { extra: {} }

      if (state.profile.extra) {
        if (state.profile.extra.order_tags) {
          orderTags = [...state.profile.extra.order_tags]
        }

        editObject = {
          extra: { ...state.profile.extra }
        }
      }

      if (orderTags.includes(name)) {
        const index = orderTags.findIndex((t) => t === name)
        orderTags.splice(index, 1)
      } else return reject()

      editObject = {
        extra: {
          ...editObject.extra,
          order_tags: orderTags
        }
      }

      const params = { ...editObject, token: state.token }

      updateProfile(params)
        .then((res) => {
          if (res.data) {
            const newProfile = { ...state.profile, ...editObject }
            commit(types.UPDATE_PROFILE, newProfile)

            updateItemStorage(LOCAL_STORAGE_KEY__USER, editObject)
            resolve()
          } else {
            reject()
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  setStartROTourFromNewOrder: ({ commit }, value) => {
    commit(types.SET_START_RO_TOUR_FROM_NEW_ORDER, value)
  },
  setOpenSelectCategory: ({ commit }, value) => {
    commit(types.SET_OPEN_SELECT_CATEGORY, value)
  },
  updateUserRegion: ({ state }, params) => {
    if (
      state.token &&
      (!state.profile || !state.profile.city_id || state.profile.city_id.length === 0)
    ) {
      updateProfile(params)
        .then(() => {
          console.log('Update city_id Successfull')
        })
        .catch((error) => {
          console.log('Error update city_id', error)
        })
    }
  },
  // setFBPageContact: ({ commit }, value) => {
  //   commit(types.SET_FB_PAGE_CONTACT, value);
  // },
  updateBankInfo: ({ state, commit }, params = {}) => {
    if (state.profile) {
      commit(types.UPDATE_BANK_INFO, {
        wallet_info: {
          bank: {
            name: params.bankName,
            account_id: params.accountNumber,
            account_name: params.accountHolder,
            branch: params.branchName,
            last_update: params.lastUpdate
          }
        }
      })
    }
  },
  async getbankList({ commit }) {
    const data = await loadbankList()
    let dataBank = []
    let dataBranch = []

    data.forEach((value) => {
      let banks = {
        code: value.code,
        name: value.name,
        short_name: value.short_name || value.name,
        icon: value.icon || null
      }

      dataBank.push(banks)

      if (value.branch && value.branch.length > 0) {
        value.branch.forEach((vl) => {
          let branchs = {
            parent_code: value.code,
            name: vl.name
          }

          dataBranch.push(branchs)
        })
      }
    })

    if (dataBank && dataBank.length > 0) {
      commit(types.UPDATE_BANKS_LIST, dataBank)
    }

    if (dataBranch && dataBranch.length > 0) {
      commit(types.UPDATE_BRANCH_BANKS_LIST, dataBranch)
    }
  },
  async handleLoadUserCategory({ state, commit }) {
    const { loadingUserCategory } = state

    if (!loadingUserCategory) {
      try {
        commit(types.LOADING_USER_CATEGORY, true)
        const data = await getUserCategory()
        if (data) {
          commit(types.LOAD_USER_CATEGORY_SUCCESS, data)
        }
      } catch (error) {
        console.error(error)
      } finally {
        commit(types.LOADING_USER_CATEGORY, false)
      }
    }
  },
  updateUserCategories({ state, commit }, { item, focusPush = false }) {
    const { userCategories, userCategoryGroups } = state
    // Set/remove in userCategories
    let _userCategories = [...userCategories]
    const index = _userCategories.findIndex((c) => c.code === item.code)

    if (index === -1) {
      _userCategories.push(item)

      // Set group if not exists before
      const group = userCategoryGroups.find((g) => g === item.parent_code)
      if (!group) {
        let _userCategoryGroups = [...userCategoryGroups]
        _userCategoryGroups.push(item.parent_code)

        commit(types.UPDATE_USER_CATEGORY_GROUPS, _userCategoryGroups)
      }
    } else {
      if (!focusPush) _userCategories.splice(index, 1)
    }

    commit(types.UPDATE_USER_CATEGORIES, _userCategories)
  },
  updateUserCategoryGroup({ state, commit }, { code, forcePush = false }) {
    const { userCategories, userCategoryGroups } = state

    let _userCategoryGroups = [...userCategoryGroups]
    const index = _userCategoryGroups.findIndex((g) => g === code)

    if (index !== -1) {
      if (!forcePush) {
        _userCategoryGroups.splice(index, 1)

        // Remove categories from group
        const categoriesFromGroup = userCategories.filter((c) => c.parent_code === code)
        if (categoriesFromGroup.length > 0) {
          let _userCategories = [...userCategories]

          categoriesFromGroup.forEach((c) => {
            const indexCategory = _userCategories.findIndex((i) => i.code === c.code)

            if (indexCategory !== -1) {
              _userCategories.splice(indexCategory, 1)
            }
          })

          commit(types.UPDATE_USER_CATEGORIES, _userCategories)
        }
      }
    } else {
      _userCategoryGroups.push(code)
    }

    commit(types.UPDATE_USER_CATEGORY_GROUPS, _userCategoryGroups)
  },
  updateUserBusiness({ state, commit }, value) {
    const { userBusiness } = state

    if (userBusiness !== value) {
      commit(types.UPDATE_USER_CATEGORIES, [])
      commit(types.UPDATE_USER_CATEGORY_GROUPS, [])
    }

    commit(types.UPDATE_USER_BUSINESS, value)
  },
  addUserCategory({ state, commit, dispatch }, { code, parent }) {
    const { userCategory, userBusiness } = state

    let _userCategory
    const payload = {
      code: code,
      level: 2,
      name: {
        en: code,
        vi: code
      },
      parent_code: parent,
      type: userBusiness
    }

    if (userCategory && Array.isArray(userCategory)) {
      _userCategory = [...userCategory]
      _userCategory.push(payload)
    } else _userCategory = [payload]

    commit(types.ADD_USER_CATEGORY, _userCategory)
    dispatch('updateUserCategories', { item: payload, focusPush: true })
  },
  submitCategory({ state, commit, rootState }, data) {
    return new Promise((resolve, reject) => {
      const { userCategories, userBusiness, profile } = state

      if (userBusiness && userCategories && userCategories.length > 0) {
        let categoryGroupByParent = groupBy(userCategories, 'parent_code')
        const categories = Object.keys(categoryGroupByParent).map((key) => {
          return {
            code: key,
            child_code: categoryGroupByParent[key].map((category) => category.code)
          }
        })

        let params = {
          user_type: userBusiness,
          categories
        }

        if (data.is_verify_cod) {
          params = {
            ...params,
            extra: {
              ...state.profile.extra,
              ...rootState.verifyAccount.formInfoVerifyAccount
            }
          }

          state.tempCategoryVerifyAccount = categories
          resolve(params)
        } else {
          if (data.update_profile) {
            updateProfile(params)
              .then(() => {
                commit(types.UPDATE_PROFILE, { ...profile, ...params })
                updateItemStorage(LOCAL_STORAGE_KEY__USER, params)
                resolve()
              })
              .catch((error) => reject(error))
          } else {
            resolve(params)
          }
        }
      } else {
        reject('An unexpected error has occurred while submiting')
      }
    })
  },
  resetSelectedCategory({ commit }) {
    commit(types.UPDATE_USER_BUSINESS, null)
    commit(types.UPDATE_USER_CATEGORIES, [])
    commit(types.UPDATE_USER_CATEGORY_GROUPS, [])
  },
  mapCategoryFromProfile({ commit, state }) {
    const { profile, userCategory } = state

    if (profile && profile._id) {
      let selectedGroups = [],
        selectedCategories = [],
        _userCategory = (userCategory && Array.isArray(userCategory) && [...userCategory]) || []

      if (profile.user_type && profile.categories && profile.categories.length > 0) {
        profile.categories.forEach((group) => {
          if (group.code) {
            selectedGroups.push(group.code)

            if (group.child_code && group.child_code.length > 0) {
              group.child_code.forEach((category) => {
                const payload = {
                  code: category,
                  level: 2,
                  name: {
                    en: category,
                    vi: category
                  },
                  parent_code: group.code,
                  type: profile.user_type
                }
                selectedCategories.push(payload)

                const existedInMasterData = _userCategory.find((c) => {
                  return (
                    c.code === category &&
                    c.parent_code === group.code &&
                    c.type === profile.user_type
                  )
                })

                // add to master data if not existed
                if (!existedInMasterData) {
                  _userCategory.push(payload)
                }
              })
            }
          }
        })
      }

      commit(types.LOAD_USER_CATEGORY_SUCCESS, _userCategory)
      commit(types.UPDATE_USER_BUSINESS, profile.user_type)
      commit(types.UPDATE_USER_CATEGORY_GROUPS, selectedGroups)
      commit(types.UPDATE_USER_CATEGORIES, selectedCategories)
    }
  },
  addPointRewardAfterUpdateCategory() {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      try {
        const params = {
          policy_id: process.env.VUE_APP_IS_PRODUCTION === 'true' ? 'SUBMIT_CAT' : 'SUBMIT_CAT_TEST'
        }
        const data = await addPointReward(params)

        if (data) {
          return resolve()
        }
      } catch (e) {
        console.error(e)
      }
    })
  },
  async loadSavedPlaces({ commit, state }) {
    const { loadingSavedPlaces, loadedSavedPlaces } = state

    if (!loadingSavedPlaces && !loadedSavedPlaces) {
      commit(types.LOADING_SAVED_PLACES, true)

      try {
        const data = await getSavedPlaces()

        if (data) {
          commit(types.LOADED_SAVED_PLACES, true)
          commit(types.LOAD_SAVED_PLACES_SUCCESS, data)
        }
      } catch (e) {
        console.error(e)
      } finally {
        commit(types.LOADING_SAVED_PLACES, false)
      }
    }
  },
  addLocalSavedPlace({ commit, state }, place) {
    const { savedPlaces } = state

    if (place) {
      const _savedPlaces = [...savedPlaces]

      // Check case edit place
      const index = _savedPlaces.findIndex((i) => i.code === place.code)

      if (index != -1) {
        _savedPlaces.splice(index, 1)
      }

      _savedPlaces.unshift(place)

      commit(types.ADD_LOCAL_SAVED_PLACE, _savedPlaces)
    }
  },
  updateLastUsedPlaces({ commit, state }, path) {
    const { savedPlaces } = state

    if (path && path.length > 0) {
      let haveUpdate = false
      const _savedPlaces = [...savedPlaces]

      path.forEach((point, count) => {
        if (point.address_code) {
          const index = _savedPlaces.findIndex((i) => i.code === point.address_code)

          if (index !== -1) {
            haveUpdate = true

            const place = {
              ..._savedPlaces[index],
              last_used: new Date().getTime() / 1000 + count
            }

            _savedPlaces.splice(index, 1, place)
          }
        }
      })

      if (haveUpdate) {
        commit(types.ADD_LOCAL_SAVED_PLACE, _savedPlaces)
      }
    }
  },
  removeLocalSavedPlace({ commit, state }, code) {
    const { savedPlaces } = state

    if (code) {
      const _savedPlaces = [...savedPlaces]
      const index = _savedPlaces.findIndex((i) => i.code === code)

      _savedPlaces.splice(index, 1)

      commit(types.REMOVE_LOCAL_SAVED_PLACE, _savedPlaces)
    }
  },

  // Referral API
  // Check valid referrer
  checkValidReferrer({ state }) {
    return new Promise((resolve) => {
      try {
        let params = {
          token: state.token
        }
        const data = checkValidReferrer(params)

        if (data) {
          return resolve(data)
        }
      } catch (e) {
        console.error(e)
      }
    })
  },

  // get history
  getReferralHistory() {
    return new Promise((resolve) => {
      try {
        const data = getReferralHistory()

        if (data) {
          return resolve(data)
        }
      } catch (e) {
        console.error(e)
      }
    })
  },

  // get detail
  getReferralDetail({ state }, referral_id) {
    return new Promise((resolve) => {
      try {
        let params = {
          token: state.token,
          referral_id: referral_id
        }
        const data = getReferralDetail(params)

        if (data) {
          return resolve(data)
        }
      } catch (e) {
        console.error(e)
      }
    })
  },

  // End Referral API

  switchStatusAutoTransferCod({ state }, params) {
    return new Promise((resolve) => {
      try {
        params.token = state.token

        const data = switchStatusAutoTransferCod(params)

        if (data) {
          return resolve(data)
        }
      } catch (e) {
        console.error(e)
      }
    })
  },

  // eslint-disable-next-line
  getListPaymentMethods({ commit }, param) {
    return new Promise((resolve, reject) => {
      getListPaymentMethods(param)
        .then((response) => {
          if (response && response.message === 'OK' && response.data) {
            resolve(response.data)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // eslint-disable-next-line
  bindingZaloPay({ commit }, param) {
    console.log(param)
    return new Promise((resolve, reject) => {
      bindZaloPay(param)
        .then((response) => {
          if (response) {
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // eslint-disable-next-line
  bindingMomo({ commit }, param) {
    console.log(param)
    return new Promise((resolve, reject) => {
      bindMomo(param)
        .then((response) => {
          if (response) {
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // eslint-disable-next-line
  unbindingWallet({ commit }, param) {
    console.log(param)
    return new Promise((resolve, reject) => {
      unbindWallet(param)
        .then((response) => {
          if (response) {
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // eslint-disable-next-line
  // checkBalanceZaloPayAccount({commit}, param) {
  //   return new Promise((resolve, reject) => {

  //     checkBalanceZaloPay(param).then(response => {
  //       if(response) {
  //         resolve(response)
  //       }
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  getUserProfile({ commit, rootState }) {
    state.loadingProfile = true

    return new Promise((resolve, reject) => {
      let param = {
        token: rootState.token
      }
      profile(param)
        .then((response) => {
          state.loadingProfile = false
          commit(types.SET_USER_PROFILE, response.data)
          resolve(response)
        })
        .catch((error) => {
          state.loadingProfile = false
          globalMethods.$_globalMixin_requestErrorHandle(error && error.response)
          reject(error)
        })
    })
  },

  // eslint-disable-next-line
  payOrderByZaloPayWithAutoDebit({ commit }, order_id) {
    return new Promise((resolve, reject) => {
      payOrderByZaloPayWithAutoDebit(order_id)
        .then((response) => {
          if (response) {
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // eslint-disable-next-line
  payOrderByMomoWithAutoDebit({ commit }, order_id) {
    return new Promise((resolve, reject) => {
      payOrderByMomoWithAutoDebit(order_id)
        .then((response) => {
          if (response) {
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  setStatusBindZaloPay({ commit }, status) {
    commit(types.SET_STATUS_BIND_ZALOPAY, status)
  },
  setAutoDebitZaloPay({ commit }, data) {
    commit(types.SET_AUTO_DEBIT_ZALOPAY, data)
  },

  // Verify account

  verifyAccount({ commit, state }, data) {
    if (!data.token) {
      data.token = state.token
    }
    return new Promise((resolve, reject) => {
      verifyAccount(data)
        .then((response) => {
          if (response && response.success) {
            const newProfile = {
              ...state.profile,
              ...{ extra: { ...state.profile.extra, ...data } }
            }
            commit(types.UPDATE_PROFILE, newProfile)
            updateItemStorage(LOCAL_STORAGE_KEY__USER, newProfile)
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // refresh firebas token
  // eslint-disable-next-line
  refreshFirebaseToken({ commit }, param) {
    return new Promise((resolve, reject) => {
      refreshFirebaseToken(param)
        .then((response) => {
          if (response) {
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // eslint-disable-next-line
  getScreenConfig({ commit }, params) {
    return new Promise((resolve, reject) => {
      getScreenConfig(params)
        .then((response) => {
          if (response) {
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  async getListFavoriteDriver({ commit }) {
    const { loadingFavoriteDriver } = state

    if (!loadingFavoriteDriver) {
      commit(types.LOADING_FAVORITE_DRIVER, true)

      try {
        const data = await getDriver({ token: state.token })

        if (data) {
          commit(types.LOADING_FAVORITE_DRIVER, false)
          commit(types.LOAD_FAVORITE_DRIVER_SUCCESS, data)
        }
      } catch (e) {
        console.error(e)
      } finally {
        commit(types.LOADING_FAVORITE_DRIVER, false)
      }
    }
  },

  async addFavoriteDriver({ commit }, params) {
    commit(types.LOADING_FAVORITE_DRIVER, true)

    try {
      params.token = state.token
      const data = await addDriver(params)
      if (data) {
        commit(types.LOADING_FAVORITE_DRIVER, false)
        return data
      }
      return false
    } catch (e) {
      return e
    }
  },

  async removeFavoriteDriver({ commit }, params) {
    commit(types.LOADING_FAVORITE_DRIVER, true)

    try {
      params.token = state.token
      const data = await removeDriver(params)

      if (data) {
        commit(types.LOADING_FAVORITE_DRIVER, false)
        return data
      }
      return false
    } catch (e) {
      return e
    }
  },

  // eslint-disable-next-line
  bindingShopeePay({ commit }, param) {
    return new Promise((resolve, reject) => {
      bindShopeePay(param)
        .then((response) => {
          if (response) {
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // eslint-disable-next-line
  payOrderByShopeePayWithAutoDebit({ commit }, order_id) {
    return new Promise((resolve, reject) => {
      payOrderByShopeePayWithAutoDebit(order_id)
        .then((response) => {
          if (response) {
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  setStatusBindShopeePay({ commit }, status) {
    commit(types.SET_STATUS_BIND_SHOPEEPAY, status)
  },
  setAutoDebitShopeePay({ commit }, data) {
    commit(types.SET_AUTO_DEBIT_SHOPEEPAY, data)
  },
  setStatusBindMomo({ commit }, status) {
    commit(types.SET_STATUS_BIND_MOMO, status)
  },
  setAutoDebitMomo({ commit }, data) {
    commit(types.SET_AUTO_DEBIT_MOMO, data)
  },

  // eslint-disable-next-line
  getShopeePayToken({ commit }, param) {
    return new Promise((resolve, reject) => {
      getShopeePayToken(param)
        .then((response) => {
          if (response) {
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line
  getListPartner({ commit }, params) {
    return new Promise((resolve, reject) => {
      getListPartner(params)
        .then((response) => {
          if (response) {
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  setPartnerFromToken({ commit }, data) {
    commit(types.SET_PARTNER_GET_FROM_TOKEN, data)
  }
}

const countries = {
  state,
  getters,
  mutations,
  actions
}

export default countries
